<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="from-label">Eğitim Durumu</label>
            <v-select-list v-model="status" placeholder="Eğitim Durumu" label="Name" :options="statuses"/>
        </div>
        <template v-if="$safe(status,'Input') == 0">
            <div class="col-12 mb-1">
                <label class="from-label">Üniversite</label>
                <v-select-list v-model="university" v-on:input="getUniversityDepartments(true)" placeholder="Üniversite" label="Name" :options="universities"/>
            </div>
            <div class="col-12 mb-1">
                <label class="from-label">Bölüm</label>
                <v-select-list v-model="department" :disabled="!value.UniversityId" placeholder="Bölüm" label="Name" :options="departments"/>
            </div>
        </template>
        <div v-else class="col-12 mb-1">
            <label class="from-label">Kurum</label>
            <input class="form-control" v-model="value.Value" placeholder="Kurum" />
        </div>
        <div class="col-12 mb-1">
            <label class="from-label">Başlangıç Tarihi</label>
            <v-date-picker v-model="value.StartTime" placeholder="Başlangıç Tarihi"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="from-label">Bitiş Tarihi</label>
            <v-date-picker v-model="value.EndTime" placeholder="Bitiş Tarihi"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="from-label">Mezuniyet Puanı</label>
            <input type="number" class="form-control" v-model="value.Degree" placeholder="Mezuniyet Puanı" />
        </div>
        <div class="col-12 mb-1">
            <label class="from-label">Diploma Numarası</label>
            <input class="form-control" v-model="value.CertificateNumber" placeholder="Diploma Numarası" />
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.Graduated">Mezun</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'
import SystemDataApi from '@/api/system-data'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
    data() {
        return {
            statuses:[],
            universities:[],
            departments:[]
        }
    },
    watch:{
        "value.UniversityId"(newValue,oldValue){
            if(newValue != oldValue){
                this.value.UniversityDepartmentId = null
                this.value.UniversityDepartmentName = null
            }
        }
    },
    mounted(){
        this.getStatuses()
        this.getUniversities()
        this.getUniversityDepartments()
    },
    methods:{
        getStatuses(){
            SystemDataApi.EducationStatus().then(res=>{
                this.statuses = res.data.Data
            })
        },
        getUniversities(){
            SystemDataApi.University().then(res=>{
                this.universities = res.data.Data
            })
        },
        getUniversityDepartments(bool){
            if(bool) this.value.UniversityDepartmentId = null
            if(this.value.UniversityId){
                SystemDataApi.UniversityDepartment(this.value.UniversityId).then(res=>{
                    this.departments = res.data.Data
                })
            }
        }
    },
    computed:{
        status:{
            get:function(){
                return this.statuses.find(b=>b.Id==this.value.EducationStatusId)
            },
            set:function(value){
                this.value.EducationStatusId = value?.Id || null
                this.value.EducationStatusName = value?.Name
            }
        },
        university:{
            get:function(){
                return this.universities.find(b=>b.Id==this.value.UniversityId)
            },
            set:function(value){
                this.value.UniversityId = value?.Id || null
                this.value.UniversityName = value?.Name
            }
        },
        department:{
            get:function(){
                return this.departments.find(b=>b.Id==this.value.UniversityDepartmentId)
            },
            set:function(value){
                this.value.UniversityDepartmentId = value?.Id || null
                this.value.UniversityDepartmentName = value?.Name
            }
        }
    }
}
</script>

<style>

</style>